
import { useStore } from 'vuex'
import Button from '@/components/elements/Button.vue'
import { dateFormat } from '@/utils/commonMethods'

export default {
  name: 'HospitalCassetteSimple',

  components: {
    Button
  },

  props: {
    items: {
      type: Object,
      default: () => ({})
    },
    page: String,
    isSeminar: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any) {
    const store = useStore()

    const dataCheck = (id: number, data: string) => {
      const dataString = !props.isSeminar ? data : `s_${data}`
      const historyIds = store.state.userInfo[dataString + '_history'].map(
        (el: any) => {
          return el.hospital_id
        }
      )
      const isActive = historyIds.indexOf(id) !== -1

      return isActive ? 'on' : 'off'
    }

    return {
      dataCheck,
      dateFormat
    }
  }
}
